import $ from "jquery";

/**
 * Loads Delius, the "Cursive Font" translation font (`$handwriting-font` in
 * _constants.scss).
 */
export default function () {
  if ($("#handwritingFont").length === 0) {
    $("head").append(
      '<link id="handwritingFont" href="//fonts.googleapis.com/css?family=Delius" ' +
        'rel="stylesheet" type="text/css">'
    );
  }
}
